<div class="row w-100 d-none d-lg-flex p-0 align-items-center">
    <div class="col-5 firstcol text-truncate">{{action.fullName}}</div>
    <div class="col-6">
        <!-- If signingfield NOT placed -->
        <ng-container *ngIf="showPlaceButton">
            <button class="btn btn-sm btn-warning" (click)="OpenPDFViewer()" translate="Button.Place"></button>
        </ng-container>

        <!-- Else -->
        <ng-container *ngIf="!showPlaceButton">
            {{'Button.' + action.action | translate}}
        </ng-container>
    </div>
    <!-- <div class="col-2">
        <ng-container *ngIf="isSignAction(action.action)">
            <div ngbDropdown class="dropdown" ngDefaultControl name="signatureType" id="signatureType">
                <button class="btn btn-sm dropdown-toggle form-control text-truncate default fs-12" [ngClass]="{'btn-dropdown-disabled': workflowDataStep3 && !workflowDataStep3.allowEditSignatureType }" type="button" id="dropdownMenu" ngbDropdownToggle>
                    <span class="w-75">{{ "Settings.AccountSignatureSection." + ((workflowDataStep3 && workflowDataStep3.defaultSignatureType === "Advanced") ? "AdvancedElectronicSignature" : "QualifiedElectronicSignature") | translate }}</span>
                    <i class="bi bi-chevron-down float-end" aria-hidden="true"></i>
                </button>
                <div ngbDropdownMenu aria-labelledby="dropdownMenu">
                    <button ngbDropdownItem value="Advanced" translate="Settings.AccountSignatureSection.AdvancedElectronicSignature"></button>
                    <button ngbDropdownItem value="Qualified" translate="Settings.AccountSignatureSection.QualifiedElectronicSignature"></button>
                </div>
            </div>
        </ng-container>
    </div>
    <div class="col-2">
        <ng-container *ngIf="isSignAction(action.action)">
            <div ngbDropdown class="dropdown" ngDefaultControl name="signatureProvider" id="signatureProvider">
                <button class="btn btn-sm dropdown-toggle form-control text-truncate default fs-12" [ngClass]="{'btn-dropdown-disabled': workflowDataStep3 && !workflowDataStep3.allowEditSignatureType }" type="button" id="dropdownMenu" ngbDropdownToggle>
                    {{workflowDataStep3!.defaultSignatureProvider}}
                    <em class="bi bi-chevron-down float-end" aria-hidden="true"></em>
                </button>
                <div ngbDropdownMenu aria-labelledby="dropdownMenu">
                    <button ngbDropdownItem value=""></button>
                </div>
            </div>
        </ng-container>
    </div> -->
    <div class="col-1 text-end">
        <span class="float-end">
            <div class="btn-group">
                <ng-container *ngIf="allowEditSignaturefield(action.action) || isDeleteAllowedForThisAction()">
                    <button type="button" class="btn bg-transparent border-0 p-0" data-bs-toggle="dropdown"
                        aria-expanded="false">
                        <i class="bi bi-three-dots bi-large"></i>
                    </button>
                    <ul class="dropdown-menu">
                        <!-- PLACE FIELD BUTTON-->
                        <ng-container *ngIf="allowEditSignaturefield(action.action)">
                            <li (click)="OpenPDFViewer()"><a class="dropdown-item pt-1 pb-1"
                                    translate="Button.Edit"></a>
                            </li>
                        </ng-container>
                        <!-- DELETE BUTTON-->
                        <ng-container *ngIf="isDeleteAllowedForThisAction()">
                            <li (click)="DeleteActor()"><a class="dropdown-item pt-1 pb-1" translate=Button.Delete></a>
                            </li>
                        </ng-container>
                    </ul>
                </ng-container>
            </div>
        </span>
    </div>
</div>